
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/sources/amazon-kinesis",
      function () {
        return require("private-next-pages/events/sources/amazon-kinesis.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/sources/amazon-kinesis"])
      });
    }
  